// Tokens do redesign (fiel ao mock .dc.html do usuário). Estilos inline p/ pixel-perfect.
import type { CSSProperties } from 'react';

export const C = {
  ink: '#161c2b', inkSoft: '#3a4155', muted: '#6b7285', mutedSoft: '#8a91a3', faint: '#a3a9b8',
  line: '#e8eaf0', lineSoft: '#eef0f5', field: '#dfe2ea', bg: '#f4f5f8', surface: '#fff', surfaceSoft: '#fbfbfd',
  navy: '#0e1526', brand: '#6a5cf0', brandDark: '#5a4be2', brandSoft: '#f4f2ff', green: '#10b981', greenDark: '#0b7355', red: '#a83232',
};
export const HATCH = 'repeating-linear-gradient(135deg, #e6e8f0 0 8px, #eff1f7 8px 16px)';
export const HATCH_SM = 'repeating-linear-gradient(135deg, #e6e8f0 0 6px, #eff1f7 6px 12px)';
export const MONO = "'JetBrains Mono', ui-monospace, monospace";

export const card: CSSProperties = { background: C.surface, border: '1px solid ' + C.line, borderRadius: 16, boxShadow: '0 1px 2px rgba(16,22,40,.04)' };
export const label: CSSProperties = { fontSize: 12, fontWeight: 700, letterSpacing: '.04em', textTransform: 'uppercase', color: C.mutedSoft };
export const input: CSSProperties = { border: '1px solid ' + C.field, borderRadius: 10, padding: '11px 13px', fontSize: 14, background: C.surfaceSoft, color: C.ink, width: '100%', outline: 'none' };
export const smallInput: CSSProperties = { ...input, borderRadius: 8, padding: '8px 10px', fontSize: 12.5, background: C.surface };
export const pill = (bg: string, fg: string): CSSProperties => ({ fontSize: 11.5, fontWeight: 700, padding: '5px 10px', borderRadius: 999, background: bg, color: fg });
export const dot = (bg: string, fg = '#fff'): CSSProperties => ({ width: 22, height: 22, flex: '0 0 22px', borderRadius: 999, background: bg, color: fg, fontSize: 12, fontWeight: 800, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' });
export const spinnerStyle = (size = 22, thickness = 2.5): CSSProperties => ({ width: size, height: size, flex: '0 0 ' + size + 'px', borderRadius: 999, border: thickness + 'px solid #ddd8fb', borderTopColor: C.brand });
export const modalOverlay: CSSProperties = { position: 'fixed', inset: 0, background: 'rgba(14,21,38,.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 40, zIndex: 50 };
export const modalCard = (maxWidth: number): CSSProperties => ({ width: '100%', maxWidth, background: C.surface, borderRadius: 18, overflow: 'hidden', boxShadow: '0 24px 60px rgba(14,21,38,.28)' });

// Cor determinística por nome de variável (mesma cor no editor, preview e chips).
const VAR_PALETTE = [
  { bg: '#efedfe', fg: '#5b4ae0' }, // roxo
  { bg: '#e7f8f1', fg: '#0b7355' }, // verde
  { bg: '#e6f2ff', fg: '#1f6fb2' }, // azul
  { bg: '#fdeef2', fg: '#b0306a' }, // rosa
  { bg: '#fff2e0', fg: '#b3611e' }, // laranja
  { bg: '#f0ecff', fg: '#7c3aed' }, // violeta
  { bg: '#fdf6dd', fg: '#8a6d10' }, // âmbar
  { bg: '#e3f7f6', fg: '#0e7c74' }, // teal
];
export function varColor(name: string): { bg: string; fg: string } {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0;
  return VAR_PALETTE[h % VAR_PALETTE.length];
}

export const STATUS_META: Record<string, { label: string; bg: string; fg: string }> = {
  draft: { label: 'Rascunho', bg: '#f2f3f7', fg: '#6b7285' },
  sending: { label: 'Em análise', bg: C.brandSoft, fg: C.brandDark },
  approved: { label: 'Aprovado', bg: '#e7f8f1', fg: C.greenDark },
  rejected: { label: 'Reprovado', bg: '#fcecec', fg: C.red },
};
